// Changelog data based on actual git commit history and real dates
// Commits have been intelligently grouped into meaningful releases

const changelogData = [
    {
        version: "3.0.0",
        date: "September, 2025",
        type: "major",
        title: "Added Learn DSA page",
        description: "New Learn DSA page replacing DSA Cheatsheet and DSA Flashcards",
        details: [
            "Added Learn DSA page",
            "Moved DSA Cheatsheet and DSA Flashcards to Learn DSA page as Archives",
            "Removed DSA Cheatsheet and DSA Flashcards from the header",
            "Added Learn DSA to sitemap.xml + removed DSA Cheatsheet and DSA Flashcards from it"
        ],
    },
    {
        version: "2.2.0",
        date: "July, 2025",
        type: "feature",
        title: "New Changelog feature",
        description: "Added a new changelog feature to the website to track new features, changes and updates easily.",
        details: [
            "Added Changelog feature",
            "Added changelog data since the initial launch",
            "Redesigned the changelog page to be more user-friendly and informative",
            "Modified the changelog button in the header to be more discrete and less intrusive",
            "Reorganized changelog data according to the actual git commit history and real dates",
            "Added SEO for Changelog page + Added it to sitemap.xml"
        ],
    },
    {
        version: "2.1.1",
        date: "July, 2025",
        type: "improvement",
        title: "Advanced DSA Features & Search",
        description: "Major enhancement of the learning platform with comprehensive search and filtering capabilities",
        details: [
            "Added comprehensive keyword search system supporting conceptual queries",
            "Expanded algorithm database to 100+ algorithms across multiple categories", 
            "Introduced 3 new algorithm categories: Advanced Sorting, String Matching, and AI Algorithms",
            "Added category filtering system to both Cheatsheet and Flashcards",
            "Implemented 404 error handling with automatic home redirection",
            "Optimized SEO configuration and Google robot indexing",
            "Enhanced meta tags and search discoverability"
        ],
    },
    {
        version: "2.1.0",
        date: "July, 2025", 
        type: "feature",
        title: "Interactive Flashcards Launch",
        description: "Launched the complete flashcard system with advanced navigation and user experience",
        details: [
            "Implemented core flashcard logic with answer validation and feedback",
            "Completed interactive flashcard design with hint system and progressive difficulty",
            "Enhanced navigation with clear separation between portfolio and learning content",
            "Enhanced flashcard input interface for better user experience"
        ],
    },
    {
        version: "2.0.0",
        date: "July, 2025",
        type: "major", 
        title: "DSA Learning Platform Foundation",
        description: "Initial launch of the Data Structures & Algorithms learning system with comprehensive content",
        details: [
            "Launched comprehensive DSA Cheatsheet with categorized algorithms",
            "Added 40+ algorithms to feature",
            "Added 10 categories to DSA Cheatsheet",
            "Added WorkAxle experience with hybrid work details",
            "Fixed mobile responsiveness issues in Experience timeline",
            "Improved overall mobile design and touch interactions",
        ],
    },
    {
        version: "1.3.0",
        date: "June, 2025",
        type: "improvement",
        title: "Resume Updates & Professional Content", 
        description: "Updated resume and enhanced professional presentation across the platform",
        details: [
            "Updated resume with latest experience and contact information",
            "Cleaned up resume file structure and naming conventions",
            "Merged resume update pull request with improved version",
            "Replaced resume with updated professional version"
        ],
    },
    {
        version: "1.2.0", 
        date: "May, 2025",
        type: "feature",
        title: "Enhanced Portfolio Features & Analytics",
        description: "Major expansion of portfolio functionality with projects, analytics, and improved user experience",
        details: [
            "Built comprehensive Projects section with technical details",
            "Updated navigation header with new sections and improved layout",
            "Added resume download, LinkedIn, and GitHub integration buttons",
            "Improved footer with direct LinkedIn messaging capability",
            "Integrated Vercel Analytics for performance monitoring",
            "Added Vercel Speed Insights for optimization tracking",
            "Enhanced timeline filters for better experience browsing",
            "Improved introduction text and professional presentation",
            "Added website favicon and proper title configuration"
        ],
    },
    {
        version: "1.1.1",
        date: "April, 2025", 
        type: "improvement",
        title: "Content Polish & Mobile Optimization",
        description: "Focused on content quality, mobile responsiveness, and visual improvements",
        details: [
            "Fixed timeline display issues on mobile devices",
            "Cleaned up unused imports and optimized code structure",
            "Polished introduction text and fixed content typos",
            "Added URL information to resume section",
            "Implemented Open Graph images for better social media sharing",
            "Updated content in Timeline sections",
            "Fixed package.json configuration issues",
            "Removed sorting functionality and added LinkedIn link in Timeline",
            "Rewrote timeline data structure for better organization",
        ],
    },
    {
        version: "1.1.0",
        date: "March, 2025", 
        type: "feature",
        title: "Core Architecture & Content Setup",
        description: "Added Timeline page with work, internship, and education data",
        details: [
            "Enhanced footer with mailto link functionality",
            "Updated main application structure",
            "Built comprehensive timeline with work, internship, and education data",
            "Implemented timeline filtering system by experience type",
            "Enhanced timeline design with better visual hierarchy",
            "Removed legacy project-related files for cleaner structure",
            "Removed ContactForm & Content components",
        ],
    },
    {
        version: "1.0.0",
        date: "February, 2025",
        type: "major", 
        title: "Initial Portfolio Launch",
        description: "Launched the foundational portfolio website with Introduction page",
        details: [
            "Set up project structure with Create React App foundation",
            "Established website baseline with React architecture",
            "Improved header design with TLDR section for quick overview"
        ],
    }
];

export default changelogData; 